import type { Resume } from '@applicator/shared'

/** Client-side filter: resume title contains query (case-insensitive). */
export function filterResumesByTitle(resumes: Resume[], searchQuery: string): Resume[] {
  const normalized = searchQuery.trim().toLowerCase()
  if (!normalized) return resumes
  return resumes.filter((resume) => resume.title.toLowerCase().includes(normalized))
}

/** When enabled, keep only resumes marked as template (order unchanged; sort separately). */
export function filterResumesByTemplateOnly(resumes: Resume[], templatesOnly: boolean): Resume[] {
  if (!templatesOnly) return resumes
  return resumes.filter((resume) => Boolean(resume.isTemplate))
}

export type ResumeListFilters = {
  titleQuery: string
  templatesOnly: boolean
}

/** Title search then optional templates-only chip; does not reorder results. */
export function filterResumeList(resumes: Resume[], filters: ResumeListFilters): Resume[] {
  const byTitle = filterResumesByTitle(resumes, filters.titleQuery)
  return filterResumesByTemplateOnly(byTitle, filters.templatesOnly)
}

export function getResumeListEmptyMessage(filters: ResumeListFilters): string {
  const hasSearch = filters.titleQuery.trim().length > 0
  if (filters.templatesOnly && hasSearch) {
    return 'No template resumes match your search.'
  }
  if (filters.templatesOnly) {
    return 'No template resumes.'
  }
  if (hasSearch) {
    return 'No resumes match your search.'
  }
  return 'No resumes yet. Create your first resume to get started.'
}
